import { AvailableLocale, BaseLocaleMessages } from './types'

export const AVAILABLE_LOCALES = ['en-US', 'es-ES', 'de-DE', 'fr-FR', 'it-IT', 'pt-BR'] as const
export const SUPPORTED_LOCALES = [...AVAILABLE_LOCALES]

export const LOCALE_IMPORT_MAP: Record<AvailableLocale, () => Promise<{ default: BaseLocaleMessages }>> = {
    'en-US': () => import('@/locales/en-US.json'),
    'es-ES': () => import('@/locales/es-ES.json'),
    'de-DE': () => import('@/locales/de-DE.json'),
    'fr-FR': () => import('@/locales/fr-FR.json'),
    'it-IT': () => import('@/locales/it-IT.json'),
    'pt-BR': () => import('@/locales/pt-BR.json'),
}

export const LOCALE_TITLES: Record<AvailableLocale, string> = {
    'en-US': 'English',
    'es-ES': 'Español',
    'de-DE': 'Deutsch',
    'fr-FR': 'Français',
    'it-IT': 'Italiano',
    'pt-BR': 'Português',
}

// Using a simpler type definition to avoid TypeScript errors
const localeRouteNameMap: Record<string, string> = {
    // to locale
    en: 'en-US',
    es: 'es-ES',
    de: 'de-DE',
    fr: 'fr-FR',
    it: 'it-IT',
    br: 'pt-BR',
    // to routeName
    'en-US': 'en',
    'es-ES': 'es',
    'de-DE': 'de',
    'fr-FR': 'fr',
    'it-IT': 'it',
    'pt-BR': 'br',
}

export const mapLocaleRouteParamName = (localeOrRoutName: string): string => localeRouteNameMap[localeOrRoutName]

export const mapLocaleToHrefLang = (locale: AvailableLocale): string =>
    ({
        'en-US': 'en',
        'es-ES': 'es',
        'de-DE': 'de',
        'fr-FR': 'fr',
        'it-IT': 'it',
        // pt-br is exception
        'pt-BR': 'pt-BR',
    })[locale]

export function resolveSupportedLocale(locale: string | undefined): AvailableLocale | undefined {
    if (!locale) {
        return undefined
    }
    if (SUPPORTED_LOCALES.includes(locale as AvailableLocale)) {
        return locale as AvailableLocale
    }

    const matchedLocale = SUPPORTED_LOCALES.find((loc) => loc.startsWith(locale))
    return matchedLocale as AvailableLocale
}
